import React from 'react';

function Aprendizagem() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Aprendizagem</h2>
      <p>Explore vídeos e conteúdos organizados para facilitar o aprendizado de eventos históricos importantes.</p>
    </div>
  );
}

export default Aprendizagem;
